export const getPreviewContainerClass = (assetType: string) => {
  if (
    assetType.startsWith('model/') ||
    assetType.startsWith('image/') ||
    assetType.startsWith('video/') ||
    assetType === 'application/rive' ||
    assetType === 'animation/vrma+gltf'
  ) {
    return "w-full flex justify-center";
  }

  return "w-full";
};